import React, { useEffect, useRef, useState } from "react";
import {
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  TablePagination,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Notification from "../../components/Notification";
import "../../tag_status.css";
// components
import CloseIcon from "@material-ui/icons/Close";
import PageTitle from "../../components/PageTitle";
import invoice_bill from "../../images/svg/invoice_svg.svg";
// data
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useFLInvoiceDataContext } from "../../context/FreelancerInvoiceDataContext.js";
import { useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import SuccessMsg from "../../images/lootie/success.json";
import ErrorMsg from "../../images/lootie/failure.json";
import WarningMsg from "../../images/lootie/warning.json";

const AlertMessagePopup = ({
  alertOpen,
  handleAlertClose,
  alertTitle,
  alertMessage,
  alertImage,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      aria-labelledby="dialog-title"
      open={alertOpen}
      width="md"
      PaperProps={{
        style: {
          width: "100%",
        },
      }}
    >
      <DialogTitle>
        <div className={classes.center} style={{ paddingTop: "15px" }}>
          <Typography style={{ fontSize: "1.3rem", fontWeight: 500 }}>
            {alertTitle}
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className={classes.center}>
          <Lottie
            style={{ width: "100px" }}
            animationData={alertImage}
            loop={true}
            autoplay={true}
          />
        </div>
        <Typography variant="body1" className={classes.center}>
          {alertMessage}
        </Typography>

        <Grid className={classes.sendWhatsapp}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={(e) => {
              handleAlertClose();
            }}
          >
            Done
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

const positions = [toast.POSITION.TOP_RIGHT];
export default function ClaimCoins() {
  const classes = useStyles();
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const token = localStorage.getItem("token");
  const history = useHistory();
  const { setInvoiceItemData } = useFLInvoiceDataContext();
  const [overAllCheckedValue, setOverAllCheckedValue] = useState(0);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [requirementsData, setRequirementsData] = useState([]);

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState(null);
  const [alertImage, setAlertImage] = useState(null);

  const showAlert = (title, message, image) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertImage(image);
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const notify = (type, customMessage) => {
    switch (type) {
      case "success":
        showAlert("Success", customMessage, SuccessMsg);
        break;
      case "error":
        showAlert("Error", customMessage, ErrorMsg);
        break;
      case "warning":
        showAlert("Warning", customMessage, WarningMsg);
        break;
      default:
        break;
    }
  };
  var [errorToastId, setErrorToastId] = useState(null);
  var [notificationsPosition] = useState(2);

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;
    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}recruiter/getInvoiceableCandidates`,
        data: {
          page: 1,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setRequirementsData(response.data.data);
          setCount(response.data.count);
        }
      });
    };
    fetchData();
  }, [token]);

  const filterRef = useRef(null);

  const [checkedIds, setCheckedIds] = useState([]);

  const handleCheckboxChange = (item, checked) => {
    if (checked) {
      setCheckedIds((prev) => [...prev, item]);
    } else {
      setCheckedIds((prev) =>
        prev.filter((checkedItem) => checkedItem.id !== item.id),
      );
    }
  };

  useEffect(() => {
    const totalInvoice = checkedIds.reduce((acc, curr) => acc + curr.amount, 0);
    setOverAllCheckedValue(totalInvoice);
  }, [checkedIds]);

  function getApprovalStatusColor(status) {
    let className;
    switch (status) {
      case "INVOICED":
        className = "neutral-extrahigh";
        break;
      case "REDEEMED":
        className = "positive-medium";
        break;
      default:
        className = "neutral-extrahigh";
        break;
    }
    return className;
  }

  const blinkIteration = {
    "--iteration-count": "infinite",
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrerntPage(newPage + 1);
    setLoader(true);

    const form = filterRef.current;
    var data = JSON.stringify({
      page: newPage + 1,
      fromDate: `${form["fromDate"].value}`,
      toDate: `${form["toDate"].value}`,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/getMyCreditsHistory`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setRequirementsData(response.data.data);
          setCount(response.data.count);
          setLoader(false);
        }

        setLoader(false);
      })
      .catch((error) => {
        handleNotificationCall("error", error);
      });
  };

  const [state, setState] = useState({
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const HeaderElements = () => (
    <>
      <Grid className={classes.HeaderElements}>Total : {count}</Grid>
    </>
  );
  const handleClaimCoins = () => {
    const isBankDetails = localStorage.getItem("isBankDetailsAvailable");
    const isBankDetailsEmpty = JSON.parse(isBankDetails);
    if (isBankDetailsEmpty === false) {
      notify(
        "error",
        <span>
          Please Fill Your Bank Details Before Invoicing <br />
          <span>
            <a
              onClick={() => history.push("/app/bank_details")}
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Click Here
            </a>
            to go bank details
          </span>
        </span>,
        ErrorMsg,
      );
      return;
    }

    if (overAllCheckedValue <= 0) {
      notify("error", "please check the candidate first", ErrorMsg);
      return;
    }
    console.log(checkedIds);
    setInvoiceItemData(checkedIds);
    history.push("vendor_invoice");
  };

  const [selectAmount, setSelectAmount] = useState([]);
  let selectId = [];

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Invoice Candidates" />
        </Grid>

        <Grid
          item
          xs={3}
          sm={5}
          md={4}
          lg={6}
          className={classes.drawerClose}
        ></Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title=""
            options={{
              pagination: false,
              sort: false,
              search: false,
              filter: false,
              download: false,
              print: false,
              viewColumns: true,
              selectableRows: "none",
              selectableRowsHeader: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
            }}
            columns={[
              {
                name: "S.No",
              },
              {
                name: "Status",
              },
              {
                name: "Candidate Name",
              },
              {
                name: "Requirement Name",
              },
              {
                name: "Payment Terms",
              },
              {
                name: "Commercial Flat Rate",
              },
              {
                name: "Billing Amount",
              },
            ]}
            data={
              requirementsData &&
              requirementsData.map((item, index) => {
                return [
                  <>
                    {currerntPage !== 0
                      ? 10 * currerntPage - 10 + index + 1
                      : index + 1}
                  </>,
                  <>
                    {item?.status === "TO-INVOICE" && (
                      <label className="cl-checkbox">
                        <input
                          type="checkbox"
                          checked={checkedIds.some(
                            (checkedItem) => checkedItem.id === item.id,
                          )}
                          style={{ cursor: "pointer" }}
                          onChange={(e) =>
                            handleCheckboxChange(item, e.target.checked)
                          }
                        />
                        <span></span>
                      </label>
                    )}

                    {item?.status !== "TO-INVOICE" && (
                      <div
                        className={`status-tag ${getApprovalStatusColor(
                          item.status,
                        )}`}
                      >
                        <i
                          className={`highlight ${getApprovalStatusColor(
                            item.status,
                          )}`}
                          style={blinkIteration}
                        ></i>
                        <p
                          className="status-tag__txt bac-l-stack-xs"
                          style={{ textTransform: "capitalize" }}
                        >
                          {item.status}
                        </p>
                      </div>
                    )}
                  </>,
                  <>
                    {item.candidate?.candidateDetail.firstName}{" "}
                    {"(" + item.candidate?.candidateDetail.lastName + ")"}{" "}
                    <br /> {"(" + item.candidate?.uniqueId + ")"}
                  </>,
                  <>
                    {item.candidate?.requirement?.requirementName +
                      " (" +
                      item.candidate?.requirement?.uniqueId +
                      ")"}
                  </>,
                  <>{item.candidate?.requirement?.joinedSharePercentage}%</>,
                  <>{item.candidate?.invoiceValue}</>,
                  <>{item.amount}</>,
                ];
              })
            }
          />

          <Grid container spacing={2} className={classes.pagination}>
            <div
              style={{
                marginTop: "20px",
                textAlign: "right",
                paddingRight: "20px",
                display: "flex",
                gap: "10px",
              }}
            >
              <p>Total Invoice Amount: </p>
              <button
                className="claim-btn-shine"
                onClick={() => {
                  handleClaimCoins();
                }}
              >
                <img
                  src={invoice_bill}
                  style={{ width: "18px", height: "18px", marginRight: "4px" }}
                  alt="coin"
                />
                <span>{overAllCheckedValue} Invoice </span>
              </button>
            </div>
          </Grid>
          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>

      <AlertMessagePopup
        alertOpen={alertOpen}
        alertTitle={alertTitle}
        alertMessage={alertMessage}
        alertImage={alertImage}
        handleAlertClose={handleAlertClose}
      />

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <ToastContainer
        closeButton={
          <CloseButton className={classes.notificationCloseButton} />
        }
        closeOnClick={false}
        hideProgressBar={true}
      />
    </>
  );
}

function CloseButton({ closeToast, className }) {
  return <CloseIcon className={className} onClick={closeToast} />;
}
